/**
 * This plugin has no state of its own — settings live in the plugin's own
 * in-memory {@link Plugin.settingsStorage}, a child feature.
 */
export type State = Record<string, never>

export namespace State {
  export const INITIAL: State = {}
}
